/**
 * The trivia join a donor asked for before they were checked in.
 *
 * Taking part is what checks a donor in (the same rule the iOS app is adopting in parallel), so
 * the pre-check-in join state collects the nickname first and then performs the page's normal
 * check-in — which may leave this page entirely for the verify-your-mobile journey at
 * `/c/<eventId>` (GH-883). The typed nickname is parked here across that hop — the same
 * park-across-a-navigation idiom `gift-attribution.ts` and `Checkout.tsx`'s handoff already use —
 * and `TriviaCard` completes the join the moment it mounts checked-in.
 *
 * `sessionStorage` on purpose: this is one tab's journey tonight, not a fact about a person. It
 * dies with the tab, never crosses tabs, and holds nothing but the display name the donor just
 * typed for a public leaderboard. Storage that refuses (private browsing) only means the donor
 * types their name once more.
 */

const key = (eventId: string): string => `givehere.trivia.join.${eventId}`;

export function parkTriviaJoin(eventId: string, displayName: string): void {
  try {
    window.sessionStorage.setItem(key(eventId), displayName);
  } catch {
    // Not parked: after check-in the donor sees the ordinary join form and types again.
  }
}

export function parkedTriviaJoin(eventId: string): string | null {
  try {
    return window.sessionStorage.getItem(key(eventId));
  } catch {
    return null;
  }
}

export function clearTriviaJoin(eventId: string): void {
  try {
    window.sessionStorage.removeItem(key(eventId));
  } catch {
    // Nothing readable to clear.
  }
}
